import {
    UPLOAD_DOCUMENT_REQUEST,
} from 'Redux/Action';
import { ArrayContains } from 'ClientService';

export const isDocumentUploading = (state) =>
    ArrayContains(state.document.openRequests, [
        UPLOAD_DOCUMENT_REQUEST,
    ]);